import styled from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { Div, FlexCol, P } from 'common/styles/oc-styled-components';
import { BREAKPOINTS, colors } from 'common/styles/style-constants';
import { Modal } from 'opencare-crown';
export const MemberIdModal = styled(Modal).attrs({
  centered: true,
  footer: null,
})`
  && {
    @media (max-width: ${BREAKPOINTS.mobileMax}px) {
      min-width: 0px;
    }

    &.ant-modal {
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        width: 100vw;
        max-width: 100vw;
        height: 100vh;
        margin: 0;
        top: 0;
      }
    }

    .ant-modal-body {
      width: 400px;
      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        max-width: 100%;
        height: 100%;
        min-height: 100vh;
        background: ${BRAND_COLORS.white};
      }
    }

    .ant-modal-content {
      width: 400px;
      margin: 0 auto;

      @media (max-width: ${BREAKPOINTS.mobileMax}px) {
        width: 100vw;
        min-height: 100vh;
        border-radius: 0;
      }
    }
  }
`;

export const SampleInsuranceCard = styled(Div)`
  background: ${colors.nickel};
  padding: 20px 20px 10px;
  border: 1px solid ${colors.silver};
  border-radius: 3px;
  width: 275px;
  align-self: center;
`;

export const MemberIdHighlight = styled(FlexCol)`
  border: 2px solid #3899f9;
  background: #d2e1f3;
  padding: 5px 10px;
  border-radius: 3px;
  margin-left: -10px;
`;

export const InsuranceCardTitle = styled(P)`
  font-size: 12px;
  margin: 0 0 -2px;
`;
